module.exports = __webpack_public_path__ + "img/icon-success-litigio.6f2fb099.svg";